import { PrecautionaryZonesModel } from '../models/precautionary-zones-model';
import { ZoneFeature } from '../models/zones-base-interfaces';
import { ZoneLayerBase } from './zone-layer-base';

export class PrecautionaryZonesLayer extends ZoneLayerBase {
    async getZones(): Promise<ZoneFeature[]> {
        const zones = await PrecautionaryZonesModel!.getPrecautionaryZones();
        return zones || [];
    }
    zoneId: string = "PrecautionaryZonesLayer";
}
